import cx from 'classnames';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  visibleOn: { id: 'Visible on', defaultMessage: 'Visible on' },
  hiddenOn: { id: 'Hidden on', defaultMessage: 'Hidden on' },
  phone: { id: 'phone', defaultMessage: 'phone' },
  tablet: { id: 'tablet', defaultMessage: 'tablet' },
  desktop: { id: 'desktop', defaultMessage: 'desktop' },
});

const DeviceIcon = ({ device, visible, intl }) => {
  const icons = {
    phone: 'fa-solid fa-mobile-screen-button',
    tablet: 'fa-solid fa-tablet-screen-button',
    desktop: 'fa-solid fa-display',
    desktop2: 'fa-solid fa-desktop',
  };

  const classes = cx(icons[device], 'device-icon', device, { visible });
  const title = `${
    visible
      ? intl.formatMessage(messages.visibleOn)
      : intl.formatMessage(messages.hiddenOn)
  } ${intl.formatMessage(messages[device])}`;

  return <span className={classes} title={title} />;
};

export default DeviceIcon;
